module.exports = __webpack_public_path__ + "img/bet_amount_icon.af136c03.svg";